export const LearnMoreStates = (() => {
	'use strict';

	let $learn;

	function init() {

		$learn = $('li.state');
		events();
		orbs();
	}

	function events(){
		/*First item on load*/
		$('li.state:first-child').addClass('active');
		$('.state--info:first-child').addClass('active');
		

		/*Toggle Statess open/closed*/
		$learn.click(function () {

			var stateAttr = $(this).data('value');

			$(this).toggleClass('active');
			$('.state--info[data-value=' + stateAttr + ']').toggleClass('active').siblings('.state--info').removeClass('active');

		});
	}

	
	function orbs(){
			
	var $parallaxOrbs = $('.orb-parallax');

	// orb parallax //
	if($parallaxOrbs.length) {

		$(window).on("load scroll", function() {

			window.requestAnimationFrame(function() {

				var windowTop = $(window).scrollTop();

				$parallaxOrbs.each(function(){

					var elementTop = $(this).offset().top,
					elementHeight = $(this).height(),
					viewPortHeight = window.innerHeight * 0.5 - elementHeight * 0.5,
					scrolled = windowTop - elementTop + viewPortHeight,
					ratio;

					switch($(this).attr('class')){
						
						case "orb-parallax orb--small": 
							ratio = -0.15;
							break;
						
						case "orb-parallax orb--xlarge": 
							ratio = -0.30;
							break;
					}

					$(this).css({
						transform: "translate3d(0," + scrolled * ratio + "px, 0)"
					});
				})

			});
		});

	} 



	}	





	return {
		init: init,
		name: 'learn-more-states'
	};
})();
